import ShopWarningIcon from '@/components/icons/shop/WarningIcon';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { getHSize, getSize } from '@/utils/size';
import useBaseSize from '@/hooks/useBaseSize';

interface ShopFnbFacilityCarouselEmptyProps {
    contrast: boolean;
    halfMode: boolean;
    isHorizontal: boolean;
    tabIndex: number;
    id?: string;
}

const ShopFnbFacilityCarouselEmpty = ({ contrast, halfMode, isHorizontal, tabIndex, id = '' }: ShopFnbFacilityCarouselEmptyProps) => {
    const { t } = useTranslation();
    const { baseWidth, baseHeight } = useBaseSize();
    const textShop = t('shop.empty.shop');
    const textNotExist = t('shop.empty.not_exist');

    const pageClassname = useMemo(() => {
        return clsx(styles['empty'], 'focus-border ', {
            [styles['empty__horizontal']]: isHorizontal,
            [styles['empty__vertical']]: !isHorizontal,
            [styles['empty__horizontal__halfmode']]: isHorizontal && halfMode,
            [styles['empty__vertical__halfmode']]: !isHorizontal && halfMode,
        });
    }, [halfMode, isHorizontal]);

    return (
        <div id={id} data-region-nav className={clsx(pageClassname)} tabIndex={tabIndex} data-interactive aria-label={t('shop.empty.tts_text')}>
            <div className={clsx(styles['empty__icon'], { [styles['empty__icon--contrast']]: contrast })}>
                <ShopWarningIcon width={getSize(50, baseWidth)} height={getHSize(50, baseHeight)} />
            </div>
            <div className={clsx(styles['empty__text'], { [styles['empty__text--contrast']]: contrast })}>
                <p>{textShop}</p>
                <p>{textNotExist}</p>
            </div>
        </div>
    );
};

export default ShopFnbFacilityCarouselEmpty;
